var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    enableBackground: "new 0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_58"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FD6925",
    d: "M250,406.25c-17.259,0-31.25-13.991-31.25-31.25s13.991-31.25,31.25-31.25s31.25,13.991,31.25,31.25 S267.259,406.25,250,406.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD6925",
    d: "M250,312.5c-8.629,0-15.625-6.996-15.625-15.625v-125c0-8.629,6.996-15.625,15.625-15.625 c8.629,0,15.625,6.996,15.625,15.625v125C265.625,305.504,258.629,312.5,250,312.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD6925",
    d: "M434.063,468.75H65.938c-17.769,0.122-34.258-9.224-43.281-24.531c-9.028-14.964-9.386-33.607-0.938-48.906 L205.781,57.344c13.436-24.421,44.125-33.327,68.545-19.892c8.383,4.611,15.281,11.51,19.893,19.892l184.063,337.969 c8.448,15.299,8.091,33.942-0.938,48.906C468.32,459.526,451.831,468.872,434.063,468.75z M250,62.5 c-6.988-0.153-13.462,3.659-16.719,9.844L49.219,410.156c-3.373,5.571-3.373,12.554,0,18.125c3.254,5.578,9.169,9.067,15.625,9.219 h369.219c6.456-0.151,12.371-3.641,15.625-9.219c3.372-5.571,3.372-12.554,0-18.125L266.719,72.344 C263.463,66.159,256.988,62.347,250,62.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.db29dc515925098d345a84a66d1a5810.svg";
export { ForwardRef as ReactComponent };